<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'medicinePieCharts',
        props: {
            'pieData': Array,
            'color': Array,
            plegendTyp: String,
            ShowText: {
                type: Boolean,
                default: () => {
                    return false
                }
            }
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                legendTyp: 'plain',
                option: {
                    legend: {},
                    series: {}
                }
            };
        },
        mounted () {
            this.legendTyp = this.plegendTyp
            this.echartObj = echarts.init(document.getElementById(this.id));
            // echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        watch: {
            pieData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            getXaxisData () {
                // 填入横轴数据
                if (this.pieData.length > 0) {
                    return this.pieData.map(item => {
                        return item.name
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                // console.log('this.pieData:', this.pieData)
                return this.pieData
            },
            setSeriesData () {
                this.setOptions('legend', (() => {
                    return {
                        // type: this.legendTyp,
                        selectedMode:false,//取消图例上的点击事件
                        orient: 'horizontal',
                        bottom: '12%',
                        icon: "rect", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
                        // y: '230px',
                        itemWidth:7,  // 设置宽度
                        itemHeight:7, // 设置高度
                        data: this.getXaxisData(),
                        itemGap:12,// 设置间距
                        textStyle:{
                            fontSize:12,
                            fontWeight:400,
                            color:"#999999"
                        }
                    }
                })());
                this.setOptions('series', (() => {
                    let that = this
                    return {
                        type: 'pie',
                        radius: '40%',
                        avoidLabelOverlap: true,
                        hoverAnimation: false,
                        silent: true,
                        center: ['50%', '40%'],
                        avoidLabelOverlap: true,
                        data: this.getSeriesData(),
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    // 自定义颜色
                                    var colorList = that.color;
                                    return colorList[params.dataIndex]
                                },
                                borderColor:"#fff",
                                borderWidth:2,
                            }
                        },
                        tooltip: {
                            trigger: "item",
                            formatter: "{a} <br/>{b}: {c}",
                        },
                        label: {
                            normal: {
                                formatter: this.ShowText ? '{b} {c}起\n占比: {d}%' : '{d}%',
                                // formatter: this.ShowText ? '{b}件 占比: {d}%' : '{d}%',
                                textStyle: {
                                    fontSize: 12,
                                    fontWeight:400,
                                    color: 'rgba(0,0,0,.55)' // 改变标示文字的颜色
                                }
                            }
                        }
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    padding: 0 16px;
    .o-echarts {
        width: 100%;
        height: 100%;
    }
}
</style>
